import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { PropertyFacilitiesMapping, syncPropertyFacilities } from '~/services/AccommodationService';

interface SyncPropertyFacilitiesParams {
  propertyId: string;
}

interface UseSyncPropertyFacilitiesOptions {
  onSuccess?: (facilities: PropertyFacilitiesMapping['facilities']) => void;
}

export function useSyncPropertyFacilities({ onSuccess }: UseSyncPropertyFacilitiesOptions = {}) {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ propertyId }: SyncPropertyFacilitiesParams) => {
      return syncPropertyFacilities({ propertyId });
    },
    onSuccess: (response) => {
      if (response.result?.facilities?.length > 0) {
        onSuccess?.(response.result.facilities);
        enqueueSnackbar('Facilities synced successfully', { variant: 'success' });
      } else {
        enqueueSnackbar(response.result?.message, { variant: 'error' });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to sync facilities: ${error.message}`, { variant: 'error' });
    },
  });
}
